import React, { useState, useEffect } from "react";
import "./AccountUserModal.scss";
import { changeUserDetails, userAddUpdateAppAccess } from "../../util/API/admin";
import { AssignDeassignRoles } from "../../util/API/admin";
import { Box, MenuItem, Select, TextField, Typography, InputLabel, Chip, Autocomplete, Grid, Divider, Tabs, Tab } from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import BaseCard from "../UI/BaseCard/BaseCard";
import BaseButton from "../UI/BaseButton/BaseButton";
import { getOptionsForSelect, setAsArray } from "../../util/utilfunctions/utilFunctions"; // If used in your project
import { stateData } from "../../constants/countrylist";
import { getCardholderemessages, getCardholdermessages } from "../../util/API/customers";
import UserEmailTable from "../UserEmailTable/UserEmailTable";
import SMStable from "../SMSTable/SMStable";
import { commonRunQuery } from "../../util/API/loans";
import BaseModal from "../UI/BaseModal/BaseModal";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      // aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="tab-panel-container"
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function AccountUserModal({
  open,
  handleClose,
  selectedUser,
  updateUser,
  setUpdateUser,
  userStatus,
  userRoles,
  portalUsers,
  handleSelectedUser
}) {
  
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    telephoneno: "",
    status: "",
    countryid: "",
    stateid: ""
  });

  const [userApiResponse, setUserApiResponse] = useState();
  const [role, setRole] = useState("");
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "error",
    header: "",
    message: "",
  });
  const [stateOptions, setStateOptions] = useState([{ key: "not-available", value: "not-available", label: "Not Available" }]);
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState(0);
  const [showData, setShowData] = useState("SMS");
  const [emailData, setEmailData] = useState([]);
  const [smsData, setSMSData] = useState([]);
  const [appsList, setAppsList] = useState([]);
  const [selectedAppId, setSelectedAppId] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);

  let isAdmin = sessionStorage.getItem("isAdmin");

  useEffect(() => {
    const updateStates = () => {
      const country = userData.countryid;
      if (!country || country === "na") {
        setStateOptions([{ key: "not-available", value: "not-available", label: "Not Available" }]);
        return;
      }

      const countryInfo = stateData.find((c) => c.iso3 === country);
      const states = countryInfo?.states || [];
      const mapped = states.length
        ? states.map((s) => ({ key: s.state_code, value: s.state_code, label: s.name }))
        : [{ key: "not-available", value: "not-available", label: "Not Available" }];

      setStateOptions(mapped);
    };

    updateStates();
  }, [userData.countryid]);

  useEffect(()=> {
    if(value == 1) {
      getMessages();
    } else if(value == 2) {
      getAppsList();
    } else {
      setEmailData([]);
      setSMSData([]);
    }
  },[value]);

  const getAppsList = async() => {
    console.log("get app list");
    try {
      const response = await commonRunQuery(314, "");
      console.log("getAppsList_response-----------", response);
      if(response?.data?.header?.callStatus == "1" && parseInt(response?.data?.header?.reccount) > 0) {
        const responseData = setAsArray(response?.data?.body?.record);
        console.log("getAppsList_responseData-----------", responseData);
        const formattedApps = responseData.map(item => ({
          label: item.apps.description + ` (${item.apps.appid})` ,  // What user sees
          appid: item.apps.appid         // What you use internally
        }));
        setAppsList(formattedApps);
      }
    } catch (error) {
      console.log("getAppsList_error---------",error);
    } finally {
      setIsLoading(false);
    }
  }

  const getMessages = async () => {
    try {
      setIsLoading(true);

      let smsMessages = await getCardholdermessages(
        selectedUser?.User?.id,
        isAdmin
      );
      let emailMessages = await getCardholderemessages(
        selectedUser?.User?.id,
      );
      let emailRecord = [];
      if (Array.isArray(emailMessages?.data?.payload?.record)) {
        emailRecord = emailMessages?.data?.payload;
      } else {
        if (emailMessages?.data?.payload == "") {
          emailRecord = emailMessages?.data?.payload;
        } else if(emailMessages?.data?.payload?.record == "") {
          console.log("Else if==========");
          emailRecord = [];
        } else {
          emailRecord["record"] = [emailMessages?.data?.payload?.record];
        }
      }
      if (smsMessages?.callStatus == 1) {
        setSMSData(smsMessages?.payload);
      }
      console.log("emailRecord===========",emailRecord);
      setEmailData(emailRecord);
    } catch (error) {
      console.log("getMessages_error===============", error);
    } finally {
      setIsLoading(false);
    }
  };


  function handleChange(evt) {
    if (role !== "") {
      setRole(evt.target.value);
    }
    const value = evt.target.value;
    setUserData({
      ...userData,
      [evt.target.name]: value,
    });
  }

  // console.log(userRoles)

  useEffect(() => {
    setUserData({
      firstName: "",
      lastName: "",
      email: "",
      telephoneno: "",
      status: "",
    })
    //This gets the portal user info with an API and then set the data for the portal user
    const getPortalUserInfo = async () => {
      if (!selectedUser) return;

      setUserData({
        firstName: selectedUser['User'].firstName,
        lastName: selectedUser['User'].lastName,
        email: selectedUser['Useremailaccount'].emailAccount,
        telephoneno: selectedUser['User'].telephoneno,
        status: selectedUser['User'].status,
        countryid: selectedUser['User'].countryid,
        stateid: selectedUser['User'].stateid
      });
      setRole(!Array.isArray(selectedUser['Securityuserrole']) ? selectedUser['Securityuserrole']?.roleid : selectedUser['Securityuserrole'][0]?.roleid);
    };
    getPortalUserInfo();
  }, [selectedUser]);

  const assignDeassign = async(merchantid, roleid, action) => {
    const response = await AssignDeassignRoles(merchantid, roleid, action);
    console.log(response);
    handleSelectedUser(selectedUser['User']?.id)
    return response
  }

  const handleAddRole = async() => {
    if (role !== "") {
      let roleExists = false;

      if (Array.isArray(selectedUser['Securityuserrole'])) {
        // Check if the role already exists in the array
        roleExists = selectedUser['Securityuserrole'].some(
          (existingRole) => existingRole.roleid === role
        );
      } else if (typeof selectedUser['Securityuserrole'] === "object" && selectedUser['Securityuserrole'] !== null) {
        // Check if the role matches the single object roleid
        roleExists = selectedUser['Securityuserrole'].roleid === role;
      }

      if (roleExists) {
        setAlert({
          ...alert,
          showAlert: true,
          message: "Cannot add role since it already exists.",
          severity: "error",
          header: "Error",
        });
        return;
      }
      
      const response2 = await assignDeassign(selectedUser['User'].id, role, 1);
      let callStatus3 = response2?.PartnerAddRemoveRoleClass?.data?.header?.callStatus;
      if (callStatus3 && callStatus3 === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          message: "User has been successfully updated.",
          severity: "success",
          header: "Success",
        });
      }
      else {
        setAlert({
          ...alert,
          showAlert: true,
          message: "Role could not be updated. Please contact support to resolve this.",
          severity: "error",
          header: "Error",
        });
      }
    }
    portalUsers()
  } 

  //Function to update the portal user info
  const updateUserInfo = async (e) => {
    e.preventDefault();

    let allFieldsFilled = true;
    const keysToExclude = ["email"];

    const listData = Object.keys(userData)
      .filter(
        (key) =>
          userData[key] !== undefined &&
          userData[key] !== null &&
          key.trim().toLowerCase() !== "role" &&
          !keysToExclude.includes(key)
      )
      .map((key) => {
        if (typeof userData[key] === "string" && userData[key].trim() === "") {
          allFieldsFilled = false;
          return null;
        }
        return `${key}|${userData[key]}`;
      })
      .filter((entry) => entry !== null)
      .join("/");

    if (!allFieldsFilled) {
      setAlert({
        ...alert,
        showAlert: true,
        message: "One or more fields are empty. All fields are required to enter",
        severity: "error",
        header: "Error",
      })
      return;
    }

    const response = await changeUserDetails(selectedUser['User'].id, listData);
    let callStatus = response?.payload?.callStatus;

    if (callStatus === "1") {
      setAlert({
        ...alert,
        showAlert: true,
        message: "User Information has been successfully updated. Roles remain unchanged.",
        severity: "success",
        header: "Success",
      });
      setUpdateUser(!updateUser);
    }

    else {
      setAlert({
        ...alert,
        showAlert: true,
        message: "User Information could not be updated",
        severity: "error",
        header: "Error",
      });
    }
    portalUsers();
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTableChange = () => {
    if (showData == "SMS") {
      setShowData("email");
    } else {
      setShowData("SMS");
    }
  };

  const handleAddAccess = async() => {
    try {
      console.log("handleAddAccess_selectedAppId------------", selectedAppId);
      console.log("handleAddAccess_selectedUser------------", selectedUser?.User?.id);
      const response = await userAddUpdateAppAccess(selectedUser?.User?.id, selectedAppId);
      console.log("handleAddAccess_response------------", response);
      if(response?.data?.header?.callStatus == "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Access granted successfully.",
        })
      }

    } catch (error) {
      console.log("handleAddAccess_error------------", error);
    }
  };

  const handleConfirmDelete = async () => {
    if (roleToDelete) {
      const response = await assignDeassign(
        selectedUser["User"].id,
        roleToDelete,
        0
      );
      if (
        response?.PartnerAddRemoveRoleClass?.data?.header?.callStatus === "1"
      ) {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Role removed successfully",
        });
        portalUsers();
      }
      setConfirmModalOpen(false);
      setRoleToDelete(null);
    }
  };

  let switchButtonText = showData === "email" ? "View SMS" : "View Emails";

  return (
      <BaseDrawer
        open={open} 
        handleClose={()=> {
          handleClose();
          setValue(0);
          setEmailData([]);
          setSMSData([]);
          setShowData("SMS")
        }} 
        height="90vh"
        title={"Admin Profile Info"}
      >
        <Box sx={{ display: "flex", height: "100%" }}>
          <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleTabChange}
              sx={{
                  borderRight: 1,
                  borderColor: "divider",
                  //indicator color
                  "& .MuiTabs-indicator": {
                      backgroundColor: "#ff972c",
                  },
                  //selected tabs
                  "& .MuiButtonBase-root.Mui-selected": {
                      color: "#ff972c",
                  },
                  //non selected tabs
                  "& .MuiButtonBase-root": {
                      color: "rgba(0, 0, 0, 0.87)",
                  },
              }}
          >
              <Tab label="Personal Information" />
              <Tab label="Communications" />
              {/* <Tab label="App Access" /> */}
          </Tabs>

          <TabPanel value={value} index={0} sx={{ flex: 1, overflowY: 'auto' }}>
            <Box sx={{ overflowY: "auto", maxHeight: 'calc(90vh - 20%)', }}>
              <BaseCard>
                <Box className="admin-details">
                  <form onSubmit={updateUserInfo}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            lineHeight: "33.6px",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                            fontStyle: "normal",
                          }}
                        >
                          First Name
                        </InputLabel>
                        <TextField
                          type="text"
                          name="firstName"
                          value={userData.firstName}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            borderRadius: "4px",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              fontSize: "12px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            lineHeight: "33.6px",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                            fontStyle: "normal",
                          }}
                        >
                          Last Name
                        </InputLabel>
                        <TextField
                          type="text"
                          name="lastName"
                          value={userData.lastName}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            borderRadius: "4px",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              fontSize: "12px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            lineHeight: "33.6px",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                            fontStyle: "normal",
                          }}
                        >
                          Email
                        </InputLabel>
                        <TextField
                          type="text"
                          name="email"
                          value={userData.email}
                          onChange={handleChange}
                          disabled
                          fullWidth
                          sx={{
                            borderRadius: "4px",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              fontSize: "12px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            lineHeight: "33.6px",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                            fontStyle: "normal",
                          }}
                        >
                          Phone
                        </InputLabel>
                        <TextField
                          type="text"
                          name="telephoneno"
                          value={userData.telephoneno}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            borderRadius: "4px",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              fontSize: "12px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            lineHeight: "33.6px",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                            fontStyle: "normal",
                            maxHeight: "40px",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              fontSize: "12px",
                              padding: "6px 10px",
                            },
                          }}
                        >
                          Status
                        </InputLabel>
                        <Select
                          name="status"
                          value={userData.status}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            height: "40px",
                            borderRadius: "4px",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            background: "white",
                            "& .MuiSelect-select": {
                              display: "flex",
                              alignItems: "center",
                              maxHeight: "40px", 
                            },
                          }}
                        >
                          {userStatus.map((row) => (
                            <MenuItem key={row.userstatus.statusID} value={row.userstatus.statusID}>
                              {row.userstatus.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            lineHeight: "33.6px",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                            fontStyle: "normal",
                          }}
                        >
                          Country
                        </InputLabel>
                        <Autocomplete
                          options={getOptionsForSelect("country")}
                          getOptionLabel={(option) => option.label}
                          isOptionEqualToValue={(option, value) => option.value === value}
                          value={
                            getOptionsForSelect("country").find(
                              (opt) => opt.value === userData.countryid
                            ) || null
                          }
                          onChange={(e, newValue) =>
                            setUserData((prev) => ({
                              ...prev,
                              countryid: newValue?.value || "",
                              stateid: "",
                            }))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select a Country"
                              fullWidth
                              sx={{
                                borderRadius: "4px",
                                fontFamily: "Inter",
                                fontSize: "12px",
                                background: "white",
                                "& .MuiInputBase-root": {
                                  maxHeight: "40px",
                                  fontSize: "12px",
                                  padding: "6px 10px",
                                },
                              }}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            lineHeight: "33.6px",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                            fontStyle: "normal",
                          }}
                        >
                          State
                        </InputLabel>
                        <Autocomplete
                          options={stateOptions}
                          getOptionLabel={(option) => option.label}
                          isOptionEqualToValue={(option, value) => option.value === value}
                          value={
                            stateOptions.find((opt) => opt.value === userData.stateid) || null
                          }
                          onChange={(e, newValue) =>
                            setUserData((prev) => ({
                              ...prev,
                              stateid: newValue?.value || "",
                            }))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select a State"
                              fullWidth
                              sx={{
                                borderRadius: "4px",
                                fontFamily: "Inter",
                                fontSize: "12px",
                                background: "white",
                                "& .MuiInputBase-root": {
                                  maxHeight: "40px",
                                  fontSize: "12px",
                                  padding: "6px 10px",
                                },
                              }}
                            />
                          )}
                        />
                      </Grid>


                    </Grid>

                    <Box className="customerdetail-btn mt-4">
                      <BaseButton
                        buttonText={"Update"}
                        type="submit"
                      />
                    </Box>
                  </form>

                  <Divider sx={{ my: 2, border: "1px solid #A6A6A6" }} />

                  <Box>
                    <Typography>Add Roles</Typography>
                    <RoleAutocomplete 
                      userRoles={userRoles} 
                      role={role} 
                      setRole={setRole} 
                      handleAddRole={handleAddRole} 
                      selectedUser={selectedUser} 
                    />
                  </Box>

                  <Divider sx={{ my: 2, border: "1px solid #A6A6A6" }} />

                  <Box>
                    <Typography>Assigned Roles</Typography>
                    <Box sx={{ mb: 3 }}>
                      <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            mt: 1,
                          }}
                        >
                    {Array.isArray(selectedUser?.["Securityuserrole"]) ? (
                      selectedUser["Securityuserrole"].length > 0 ? (
                        selectedUser["Securityuserrole"].map((role) => (
                          <Chip
                            key={role.roleid}
                            label={
                              userRoles.find(
                                (r) => r.securityrole.roleid === role.roleid
                              )?.securityrole.name
                            }
                            onDelete={() => {
                              console.log("roles-----------",selectedUser["Securityuserrole"]);
                              if(selectedUser["Securityuserrole"].length > 1) {
                                setRoleToDelete(role.roleid);
                                setConfirmModalOpen(true);
                              } else {
                                setAlert({
                                  ...alert,
                                  showAlert: true,
                                  message: "Cannot delete the only role assigned to the user. User Role should not be blank.",
                                  severity: "error",
                                  header: "Error",
                                });
                              }
                            }}
                            color="primary"
                            sx={{ fontSize: "0.875rem" }}
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="textSecondary">
                          No roles assigned.
                        </Typography>
                      )
                    ) : typeof selectedUser?.["Securityuserrole"] ===
                      "object" ? (
                      <Chip
                        key={selectedUser?.["Securityuserrole"]?.roleid}
                        label={
                          userRoles.find(
                            (r) =>
                              r.securityrole.roleid ===
                              selectedUser?.["Securityuserrole"]?.roleid
                          )?.securityrole.name
                        }
                        onDelete={() => {
                          console.log("rolessss-----------",selectedUser["Securityuserrole"]);
                          setAlert({
                            ...alert,
                            showAlert: true,
                            message: "Cannot delete the only role assigned to the user. User Role should not be blank.",
                            severity: "error",
                            header: "Error",
                          });
                          // setRoleToDelete(
                          //   selectedUser?.["Securityuserrole"]?.roleid
                          // );
                          // setConfirmModalOpen(true);
                        }}
                        color="primary"
                        sx={{ fontSize: "0.875rem" }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No roles assigned.
                      </Typography>
                    )}
                  </Box>
                  </Box>
                </Box>

              </Box>
            </BaseCard>
            <CustomAlert
              severity={alert.severity}
              show={alert.showAlert}
              header={alert.header}
              message={alert.message}
              onClick={(prev) => {
                setAlert({ ...prev, showAlert: false });
                if (alert.severity === "success") handleClose();
              }}
              autoclose={alert.severity === "error" ? false : true}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box
            className="table-sizing"
            sx={{
              overflow: "auto",
              backgroundColor: "#ffffff",
              padding: "20px",
            }}
          >
            <Box
              className="d-flex justify-content-end switch-button-container pointer"
              onClick={handleTableChange}
            >
              <Box className="switch-button">{switchButtonText}</Box>
            </Box>
            {showData == "email" ? (
              <UserEmailTable emailData={emailData} />
            ) : (
              <SMStable smsData={smsData} />
            )}
          </Box>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Box sx={{ overflowY: "auto", maxHeight: "calc(90vh - 20%)" }}>
            <BaseCard>
              <Box className="admin-details mb-3">
                Add User Specific Access
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ marginTop: "15px" }}>
                      <InputLabel
                        sx={{
                          fontWeight: "800",
                          lineHeight: "33.6px",
                          color: "#6b7280",
                          fontFamily: "Nunito",
                          fontSize: "14px",
                          fontStyle: "normal",
                        }}
                      >
                        Apps List
                      </InputLabel>
                      <Autocomplete
                        // fullWidth
                        disablePortal
                        options={appsList}
                        onChange={(e, newValue) =>
                          setSelectedAppId(newValue?.appid)
                        }
                            getOptionLabel={(option) => option.label || ""}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select app"
                                fullWidth
                                sx={{
                                  borderRadius: "4px",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  background: "white",
                                  "& .MuiInputBase-root": {
                                    maxHeight: "40px",
                                    fontSize: "12px",
                                    padding: "6px 10px",
                                  },
                                }}
                              />
                            )}
                          />
                        </Box>

                        <Box className="customerdetail-btn mt-4">
                          <BaseButton
                            buttonText={"Add Access"}
                            onClick={() => handleAddAccess()}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </BaseCard>
                <CustomAlert severity={alert.severity} show={alert.showAlert} header={alert.header} message={alert.message} onClick={(prev) => {setAlert({...prev, showAlert: false}); if (alert.severity === "success") handleClose()}} autoclose={alert.severity === "error" ? false : true} />
              </Box>
          </TabPanel>
        </Box>
      <BaseModal
        open={confirmModalOpen}
        handleClose={() => {
          setConfirmModalOpen(false);
          setRoleToDelete(null);
        }}
        headerText="Confirm Role Removal"
        width="30%" // Smaller width for confirmation
        baseHeight="auto"
      >
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontFamily: "Nunito", fontSize: "14px" }}>
            Are you sure you want to remove this role?
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}
          >
            <BaseButton
              buttonText="Cancel"
              onClick={() => {
                setConfirmModalOpen(false);
                setRoleToDelete(null);
              }}
              buttonStyle="save-button"
            />
            <BaseButton
              buttonText="Yes"
              onClick={handleConfirmDelete}
              buttonStyle="save-button"
            />
          </Box>
        </Box>
      </BaseModal>
      </BaseDrawer>
  );
}

const RoleAutocomplete = ({ userRoles, role, setRole, handleAddRole }) => {
   // Exclude External Payroll Admin across all environments
  const EXCLUDED_ROLES = {
    ids: ["847", "708"],
    names: ["External Payroll Admin"],
  };
   const filteredRoles = userRoles.filter((r) => {
    const { roleid, name } = r.securityrole;
    return (
      !EXCLUDED_ROLES.ids.includes(roleid) &&
      !EXCLUDED_ROLES.names.includes(name)
    );
  });
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
      <Autocomplete
        fullWidth
        options={filteredRoles.map((role) => ({
          key: role.securityrole.roleid,
          value: role.securityrole.roleid,
          label: role.securityrole.name,
        }))}
        getOptionLabel={(option) => option.label || ""}
        value={
          filteredRoles
            .map((role) => ({
              key: role.securityrole.roleid,
              value: role.securityrole.roleid,
              label: role.securityrole.name,
            }))
            .find((opt) => opt.value === role) || null
        }
        onChange={(event, newValue) => {
          if (newValue) {
            setRole(newValue.value);
          } else {
            setRole("");
          }
        }}
        sx={{
          flexGrow: 1,
          height: "40px", // Ensure height matches the button
          "& .MuiInputBase-root": {
            height: "40px", // Align Autocomplete input height with the button
            minHeight: "40px",
            marginTop: "5px",
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select a Role"
            variant="outlined"
            sx={{
              width: "100%",
              height: "40px", // Match the height of the button
              borderRadius: "4px",
              fontFamily: "Inter",
              fontSize: "12px",
              background: "white",
              "& .MuiInputBase-root": {
                height: "40px", // Match height explicitly
                fontSize: "12px",
                padding: "6px 10px",
              },
            }}
          />
        )}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "150px",
          height: "40px",
        }}
      >
        <BaseButton buttonText={"Add Role"} onClick={() => handleAddRole()} />
      </Box>
    </Box>
  );
};

export default AccountUserModal;
